import { render, staticRenderFns } from "./WardMessageNotes.vue?vue&type=template&id=e4ff9368&scoped=true&"
import script from "./WardMessageNotes.vue?vue&type=script&lang=js&"
export * from "./WardMessageNotes.vue?vue&type=script&lang=js&"
import style0 from "./WardMessageNotes.vue?vue&type=style&index=0&id=e4ff9368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ff9368",
  null
  
)

export default component.exports